import { AUTH_ROUTES } from '@/config/constants/routes';

/**
 * Read the XSRF token Laravel sets as a cookie, for use as the X-XSRF-TOKEN
 * header on manual fetch() requests (Inertia and axios attach it themselves).
 */
export const readXsrfToken = (): string => {
    const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/);

    return match ? decodeURIComponent(match[1]) : '';
};

/**
 * Make sure the browser holds a session and an XSRF-TOKEN cookie before a
 * form on a public page posts.
 *
 * The marketing pages may be served from the CDN edge, where a first-time
 * visitor receives HTML without any Set-Cookie. Inertia signs its requests
 * with the XSRF-TOKEN cookie, so without one the very first submit would be
 * rejected as a CSRF failure. Sanctum's cookie endpoint is a tiny GET that
 * establishes both; calling it is harmless when a session already exists.
 * Failures are swallowed on purpose: the post itself reports the real error.
 */
export const primeCsrfCookie = async (): Promise<void> => {
    if (typeof document === 'undefined' || readXsrfToken() !== '') {
        return;
    }

    try {
        await fetch(route(AUTH_ROUTES.csrfCookie), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    } catch {
        // The form post will surface any real problem.
    }
};
